import NameCopy from './NameCopy';

export default NameCopy;
